export const isProduction = process.env.NODE_ENV === "production";
export const isStaging = process.env.GATSBY_STAGING === "true";

// BUILD NAME: dev-fe-agent-2025-02-05

const enum BackendUrl {
  PRODUCTION = 'https://publicapi.cmasa.org.au',
  STAGING = 'https://test-publicapi.cmasa.org.au',
  YUWEN = 'http://192.168.15.251:5001',
  OFFICE_SERVER = 'http://192.168.15.252:5001',
}

const prodBackEndUrl = BackendUrl.PRODUCTION;
const stagingBackEndUrl = BackendUrl.STAGING;
const devBackEndUrl = BackendUrl.OFFICE_SERVER;

export const backEndBaseURL = isStaging ? stagingBackEndUrl : isProduction ? prodBackEndUrl : devBackEndUrl;

export const memberPortalUrl = isStaging ? "https://test-member.cmasa.org.au" : isProduction ? "https://member.cmasa.org.au" : "http://192.168.15.2:9001";

export const encryptedPassword = "*ENCRYPTEDPASSWORD*";

export const version = "0.19.1";
